import { z } from "zod/mini"

import { SliceLegacySchema } from "./slice"

// Item
export const SliceItemLegacySchema = z.object({
	key: z.string(),
	label: z.nullish(z.string()),
	value: SliceLegacySchema,
})

export type SliceItemLegacy = z.infer<typeof SliceItemLegacySchema>

// Slices
export const SlicesLegacySchema = z.array(SliceItemLegacySchema)

export type SlicesLegacy = z.infer<typeof SlicesLegacySchema>
